/*
  THAANI — Kaufleiste als schwebende Pille (snippets/thaani-sticky-atc.liquid)

  Die Pille kommt, wenn zwei Dinge gelten: Der Kaufknopf der Kaufkarte liegt
  oben ausserhalb des Bildes, und der Kopf ist beim Runterscrollen
  weggegangen (Klasse is-hidden an [data-ui-header]). Scrollt man hoch, kommt
  der Kopf zurueck und die Pille geht. Ohne Kopf zaehlt die Scrollrichtung.

  Der Knopf haengt ueber das form-Attribut am Produktformular, es braucht also
  kein eigenes Warenkorb-JS. Gesperrt ist er, solange der Kaufknopf der Karte
  gesperrt ist (vor dem Verkaufsstart «Bald erhaeltlich»). Plus und Minus
  druecken die Knoepfe der Kaufkarte, damit Packung, Preis und Versandhinweis
  dort weiter stimmen. Den Preis zieht assets/thaani-ui-buybox.js nach, bei
  einem Variantenwechsel zusaetzlich das Dawn-Event PUB_SUB_EVENTS.variantChange.
*/

class ThaaniStickyAtc extends HTMLElement {
  connectedCallback() {
    this.anchor = this.dataset.target ? document.querySelector(this.dataset.target) : null;
    this.button = this.querySelector('button[type="submit"]');
    this.form = this.button?.form || null;
    this.header = document.querySelector('[data-ui-header]');
    this.lastY = window.scrollY;
    this.runter = false;

    this.syncAvailability = () => {
      if (this.button && this.anchor) this.button.disabled = this.anchor.disabled;
    };
    this.syncAvailability();
    if (this.anchor) {
      this.availabilityObserver = new MutationObserver(this.syncAvailability);
      this.availabilityObserver.observe(this.anchor, { attributes: true, attributeFilter: ['disabled'] });
    }

    this.update = () => {
      this.frame = null;
      const y = window.scrollY;
      if (y !== this.lastY) this.runter = y > this.lastY;
      this.lastY = y;
      const vorbei = !!this.anchor && this.anchor.getBoundingClientRect().bottom < 0;
      const kopfWeg = this.header ? this.header.classList.contains('is-hidden') : this.runter;
      const zeigen = vorbei && kopfWeg;
      if (zeigen && !this.classList.contains('is-visible')) this.syncCount();
      this.classList.toggle('is-visible', zeigen);
    };
    this.onScroll = () => {
      if (!this.frame) this.frame = requestAnimationFrame(this.update);
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    if (this.header) {
      this.headerObserver = new MutationObserver(this.onScroll);
      this.headerObserver.observe(this.header, { attributes: true, attributeFilter: ['class'] });
    }

    this.querySelectorAll('[data-pille-schritt]').forEach((knopf) => {
      knopf.addEventListener('click', () => {
        const ziel = this.form?.querySelector(`[data-step="${knopf.dataset.pilleSchritt}"]`);
        if (ziel) ziel.click();
        this.syncCount();
      });
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        this.updatePrice(event);
      });
    }
  }

  disconnectedCallback() {
    this.availabilityObserver?.disconnect();
    this.headerObserver?.disconnect();
    window.removeEventListener('scroll', this.onScroll);
    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
      this.variantChangeUnsubscriber = null;
    }
  }

  // Anzahl aus der Kaufkarte uebernehmen
  syncCount() {
    const anzeige = this.querySelector('[data-pille-anzahl]');
    const eingabe = this.form?.querySelector('[data-count]');
    if (anzeige && eingabe) anzeige.textContent = eingabe.value || '1';
  }

  updatePrice(event) {
    const data = event && event.data;
    if (!data || !data.html || String(data.sectionId) !== this.dataset.sectionId) return;

    const target = this.querySelector('[data-ui-sticky-price]');
    const source = data.html.getElementById(`price-${data.sectionId}`);
    if (!target || !source) return;

    const priceRoot = source.querySelector('.price') || source;
    const onSale = priceRoot.classList && priceRoot.classList.contains('price--on-sale');
    const selector = onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular';
    const item = priceRoot.querySelector(selector) || priceRoot.querySelector('.price-item');

    if (item) target.textContent = item.textContent.trim();
  }
}

if (!customElements.get('thaani-sticky-atc')) {
  customElements.define('thaani-sticky-atc', ThaaniStickyAtc);
}
